<!-- TODO: create component BaseDeleteDialog -->
<template>
  <slot name="header_close" />
  <div class="wrapper_dialog">
    <h3 class="title">
      {{ $t("tags.delete_tag_number") }}
      <div class="number-block">
        <img class="icon" :src="messengerIcon" />
        <span>{{ number }}</span>
      </div>
    </h3>

    <div class="content">
      <i18n-t keypath="tags.delete_confirm" tag="p" class="confirm">
        <template #tag>
          <span class="value">{{ tagName }}</span>
        </template>
      </i18n-t>

      <div class="action_container">
        <ButtonLoading
          type="submit"
          :loading="button.loading"
          :disabled="button.disabled"
          @click="actionTag"
        >
          {{ $t("common.delete") }}
        </ButtonLoading>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import ButtonLoading from "@/components/Recurring/ButtonLoading.vue";
import { useStore } from "vuex";

const store = useStore();

const button = ref({
  loading: false,
  disabled: false,
});

const tagItem = computed(() => store.state.dialogParams?.info?.tags?.[0] || "");
const tagName = computed(() => tagItem.value?.name || tagItem.value);
const visibility = computed(() => store.state.dialogParams?.info?.visibility);
const number = computed(() => store.state.dialogParams?.info?.number);
const messenger = computed(() => store.state.dialogParams?.info?.messenger);
const messengerIcon = computed(() =>
  messenger.value ? require(`@/assets/icons/${messenger.value}.svg`).default : ""
);

const onToggleLoadingButton = () => {
  if (button.value.loading) {
    button.value.loading = false;
    button.value.disabled = false;
  } else {
    button.value.loading = true;
    button.value.disabled = true;
  }
};

const actionTag = async () => {
  const payload = {
    id: store.state.dialogParams?.info?.tags?.[0]?.id,
    messenger: store.state.dialogParams?.info?.messenger,
    number: store.state.dialogParams?.info?.number,
  };

  onToggleLoadingButton();

  store
    .dispatch("numbers/removeTag", payload)
    .then((res) => {
      if (!!store.getters.getNextDialog) {
        store.commit("setTagsToDialogParams", []);
        store.commit("setDialog", store.getters.getNextDialog);
        store.commit("setNextDialog", "");
      } else {
        store.commit("closeDialog");
      }
      store.dispatch("numbers/loadNumbersByMessenger", {
        messenger: payload.messenger,
        visibility: visibility.value,
      });
      //   store.dispatch("numbers/loadConnectedNumbers");
    })
    .catch(() => {
      onToggleLoadingButton();
    });
};
</script>

<style lang="scss" scoped>
@use "@/styles/dialog-form.scss";
</style>
